import { motion } from 'framer-motion';

/**
 * Background animé subtil affichant "JoSmartTech.net" en filigrane qui défile.
 * Placé en position fixed, derrière tout le contenu Academy.
 */
export default function AnimatedBrandBackground() {
  const text = 'JoSmartTech.net';
  const lines = Array.from({ length: 8 });
  return (
    <div aria-hidden="true" className="fixed inset-0 -z-10 pointer-events-none overflow-hidden" data-testid="academy-bg">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-900 to-emerald-950" />
      {/* Grain overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '40px 40px',
      }} />
      {lines.map((_, i) => (
        <motion.div
          key={i}
          className="absolute whitespace-nowrap font-black select-none"
          style={{
            top: `${10 + i * 12}%`,
            fontSize: 'clamp(2.5rem, 7vw, 6rem)',
            color: i % 2 === 0 ? 'rgba(16,185,129,0.045)' : 'rgba(250,204,21,0.04)',
            letterSpacing: '-0.04em',
          }}
          animate={{ x: i % 2 === 0 ? ['-30%', '30%'] : ['30%', '-30%'] }}
          transition={{ duration: 60 + i * 4, repeat: Infinity, repeatType: 'reverse', ease: 'linear' }}
        >
          {Array.from({ length: 4 }).map((_, k) => (
            <span key={k} className="mr-12">{text}</span>
          ))}
        </motion.div>
      ))}
    </div>
  );
}
